import React from 'react'
import Slider from 'react-slick'
import {
    Container,
    Header,
    Segment,
    Divider,
    Card,
    Image,
    Grid
} from "semantic-ui-react"
import student1 from '../images/Student/1.png'
import student2 from '../images/Student/2.png'
import student3 from '../images/Student/3.png'

const randomStudentImage = () => {
    const students = [student1, student2, student3]
    const random = Math.floor(Math.random() * students.length);
    return (
        <Image src={students[random]} wrapped ui={false} />
    )
}

const Student = () => {
    return (
        <div>
            <Slider className="slide">
                <Segment inverted vertical id="student_segment"/>
            </Slider>
            <Container>
                <Divider horizontal>
                    <Header as='h1'>
                    Thesis Advisor
                    </Header>
                </Divider>
                <p>&emsp;&emsp;Students in this program should decide their advisor and co-advisor within the first academic year after enrollment. The student should complete <a href='https://drive.google.com/file/d/16uQsRKpKfCP43sVH7CA9niGRD_oSbo5s/view?usp=sharing'>Advisor/Co-advisor Consent Form</a> and return it to the AIoT office. It shall be approved by the academic committee members. The advisor/co-advisor for the thesis dissertation must be AIoT faculty. Note that a student must choose two advisors, one from Academia Sinica and one from NTU.</p>
                <Divider horizontal>
                    <Header as='h1'>
                    Stipend Guideline
                    </Header>
                </Divider>
                <p>TBA</p>

                <Divider horizontal>
                    <Header as='h1'>
                    Current Students (Year 2024)
                    </Header>
                </Divider>
                <Grid stackable columns={4}>
                    <Grid.Row>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>Wubetu Barud Demilie</Card.Header>
                                <Card.Description>烏貝圖</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    Ethiopia
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>I Chiu</Card.Header>
                                <Card.Description>邱翊</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    Taiwan
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>Mohammadreza Kamrani</Card.Header>
                                <Card.Description>瑞薩</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    Iran
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>Mukhtiar Khan</Card.Header>
                                <Card.Description>穆赫蒂亞爾</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    Pakistan
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>Aquib Raza</Card.Header>
                                <Card.Description>阿奎布</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    India
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>Eugene Lalis Sy</Card.Header>
                                <Card.Description>施辰穎</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    Philippines
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <Divider horizontal>
                    <Header as='h1'>
                    Current Students (Year 2023)
                    </Header>
                </Divider>
                <Grid stackable columns={4}>
                    <Grid.Row>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>Luo Yao Lin</Card.Header>
                                <Card.Description>林邏耀</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    Taiwan
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>Huan-Chieh Tseng</Card.Header>
                                <Card.Description>曾煥捷</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    Taiwan
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>Rizwan Muhammad</Card.Header>
                                <Card.Description>周博翰</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    Pakistan
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>Sarafaraz Hussain</Card.Header>
                                <Card.Description>馬祖恩</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    Pakistan
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <Divider horizontal>
                    <Header as='h1'>
                    Current Students (Year 2022)
                    </Header>
                </Divider>
                <Grid stackable columns={4}>
                    <Grid.Row>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>Miguel Angel Benalcazar Hernandez</Card.Header>
                                <Card.Description>班柏瑞</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    Ecuador
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>Gladhi Guarddin</Card.Header>
                                <Card.Description>葛丁</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    Indonesia
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>Sofia Ormazabal Arriagda</Card.Header>
                                <Card.Description>鄒智文</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    Chile
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>Saeed Barkabi Zanjani</Card.Header>
                                <Card.Description>巴撒伊</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    Iran
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>Wei-Lun Chen</Card.Header>
                                <Card.Description>陳緯綸</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    Taiwan
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column>
                            <Card>
                                {randomStudentImage()}
                                <Card.Content>
                                <Card.Header>Javier Atero</Card.Header>
                                <Card.Description>艾維</Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    Spain
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        </div>
    )
}

export default Student